import type {RouterConfig} from '@nuxt/schema';

export default {
    routes: _routes => [
        {
            name: 'index',
            path: '/',
            component: () => import('~/pages/index.vue'),
        },
        {
            name: 'categories',
            path: '/kategorien',
            component: () => import('~/pages/categories/index.vue'),
        },
        {
            name: 'category',
            path: '/c/:name/:id',
            component: () => import('~/pages/categories/[id].vue'),
        },
        {
            name: 'product',
            path: '/:category/:name/:id',
            component: () => import('~/pages/product/[id].vue'),
        },
        {
            name: 'contactPerson',
            path: '/ansprechpartner/:zip?',
            component: () => import('~/pages/contactPerson.vue'),
        },
        {
            name: 'ar',
            path: '/ar/:id/:combo?',
            component: () => import('~/pages/ar.vue'),
        },
        {
            name: 'search',
            path: '/suche',
            component: () => import('~/pages/search.vue'),
        },
        {
            name: 'wishlist',
            path: '/mein-merkzettel',
            component: () => import('~/pages/user/wishlist.vue'),
        },
        {
            name: 'login',
            path: '/anmelden',
            component: () => import('~/pages/user/login.vue'),
        },
        {
            name: 'registration',
            path: '/konto-eroeffnen',
            component: () => import('~/pages/user/registration.vue'),
        },
        {
            name: 'forgot-password',
            path: '/passwort-vergessen/:hash?',
            component: () => import('~/pages/user/forgotPassword.vue'),
        },
        {
            name: 'validate-account',
            path: '/bestaetigung/:validationHash',
            component: () => import('~/pages/user/validateAccount.vue'),
        },
        {
            name: 'data-protection',
            path: '/datenschutz',
            component: () => import('~/pages/dataProtection.vue'),
        },
        {
            name: 'imprint',
            path: '/impressum',
            component: () => import('~/pages/imprint.vue'),
        },
        {
            name: 'gtc',
            path: '/agb',
            component: () => import('~/pages/gtc.vue'),
        },
        {
            name: 'material',
            path: '/Material',
            component: () => import('~/pages/material/index.vue'),
        },
        {
            name: 'playgrounds',
            path: '/Material/Spiellandschaften',
            component: () => import('~/pages/material/playgrounds.vue'),
        },
        {
            name: 'slides',
            path: '/Material/Rutschen',
            component: () => import('~/pages/material/slides.vue'),
        },
        {
            name: 'melamini',
            path: '/Material/Melamini',
            component: () => import('~/pages/material/melamini.vue'),
        },
        {
            name: 'climbing',
            path: '/Material/Kletterstrecken',
            component: () => import('~/pages/material/climbing.vue'),
        },
        {
            name: 'waterFacilities',
            path: '/Material/Wasserspielanlagen',
            component: () => import('~/pages/material/waterFacilities.vue'),
        },
        {
            name: 'metall',
            path: '/Material/Metall-4-0',
            component: () => import('~/pages/material/metall.vue'),
        },
        {
            name: 'manufacturing',
            path: '/Fertigung',
            component: () => import('~/pages/manufacturing.vue'),
        },
        {
            name: 'service',
            path: '/Service',
            component: () => import('~/pages/service/index.vue'),
        },
        {
            name: 'collaboration',
            path: '/Service/Wir-fuer-Sie',
            component: () => import('~/pages/service/collaboration.vue'),
        },
        {
            name: 'certification',
            path: '/Service/Zertifizierung',
            component: () => import('~/pages/service/certification.vue'),
        },
        {
            name: 'warranty',
            path: '/Service/Garantie-und-Wartung',
            component: () => import('~/pages/service/warranty.vue'),
        },
        {
            name: 'downloads',
            path: '/Service/Downloads',
            component: () => import('~/pages/service/downloads.vue'),
        },
        {
            name: 'contact',
            path: '/Service/Kontakt',
            component: () => import('~/pages/service/contact.vue'),
        },
        {
            name: 'inclusion',
            path: '/Service/Inklusion',
            component: () => import('~/pages/service/inclusion.vue'),
        },
        {
            name: 'montage',
            path: '/Service/Montage',
            component: () => import('~/pages/service/montage.vue'),
        },
        {
            name: 'blog',
            path: '/Blog',
            component: () => import('~/pages/blog/index.vue'),
        },
        {
            name: 'blog-post',
            path: '/Feeds/Blog-Inhalte/:slug',
            component: () => import('~/pages/blog/[slug].vue'),
        },
        {
            name: 'sustainability',
            path: '/Nachhaltigkeit',
            component: () => import('~/pages/sustainability.vue'),
        },
        {
            name: 'playgroundConfigurator',
            path: '/Spielplatz-Konfigurator',
            component: () => import('~/pages/playgroundConfigurator.vue'),
        },
        {
            name: 'arApp',
            path: '/3D-Planer-App',
            component: () => import('~/pages/arApp.vue'),
        },
        {
            name: 'career',
            path: '/Karriere-1',
            component: () => import('~/pages/career.vue'),
        },
        {
            name: 'newsletter',
            path: '/Newsletter-Anmeldung',
            component: () => import('~/pages/newsletter.vue'),
        },
        {
            name: 'newsletterUnsubscribe',
            path: '/Newsletter-Abmeldung',
            component: () => import('~/pages/newsletterUnsubscribe.vue'),
        },
    ]
} satisfies RouterConfig;
